import './index.scss';
import $ from 'jquery';
import './foundation';
import fitvids from 'fitvids';
import 'objectFitPolyfill';
import './layout/partials/solr_search_facetss';

// Initialize Foundation Sites - used for site UI kit
$(document).foundation();

// Initialize FitVids - used for maintaing aspect ratio for Video embed iframes on mobile
fitvids();

// Initialize polyfill for supporting object fit css on IE
window.objectFitPolyfill();

// Automatically expand/collapse publication search for various devices.
(function(){
	$(window).on('changed.zf.mediaquery', toggleAccourdian);
	if (window.Foundation.MediaQuery.atLeast('large')) {
		toggleAccourdian();
	}
	function toggleAccourdian () {
		const $accourdian = $('#search-accordion');
		if($accourdian.length > 0) {
			$accourdian.foundation('toggle', $('.accordion-content:first'));
		}
	}
})();

// Auto-focus search field
$('#search-dropdown, #search-dropdown-mobile').on('click', function(evt){
	evt.preventDefault();
	$('#search-dropdown-wrap').addClass('is_open');
	$('#searchform').find('input:first').focus();
});


// WEBPACK FOOTER //
// ./src/index.js